import {
  AlertTriangle,
  Ban,
  Bell,
  CalendarClock,
  Crown,
  DoorOpen,
  Gift,
  MessageSquare,
  ScrollText,
  Settings,
  ShieldAlert,
  TerminalSquare,
  TrendingUp,
  Users,
} from "lucide-react";

const toSidebarItem = ({ to, icon, label }) => ({ to, icon, label });

export const SYSTEM_SUBPAGES = {
  level: [
    {
      to: "/dashboard/xp-settings",
      icon: Settings,
      label: "XP Settings",
      labelAr: "إعدادات XP",
      labelEn: "XP Settings",
      descriptionAr: "إعدادات جمع الخبرة والمصدر الأساسي",
      descriptionEn: "XP source and earning settings",
    },
    {
      to: "/dashboard/levels",
      icon: TrendingUp,
      label: "Level Customization",
      labelAr: "تخصيص المستويات",
      labelEn: "Level Customization",
      descriptionAr: "منحنى التقدم ومكافآت المستويات",
      descriptionEn: "Progression curve and level rewards",
    },
    {
      to: "/dashboard/seasons",
      icon: CalendarClock,
      label: "Seasons",
      labelAr: "المواسم",
      labelEn: "Seasons",
      descriptionAr: "إدارة المواسم والإحصاءات",
      descriptionEn: "Seasons and statistics",
    },
    {
      to: "/dashboard/rank",
      icon: Crown,
      label: "Rank • Podium",
      labelAr: "الرانك • البوديوم",
      labelEn: "Rank • Podium",
      descriptionAr: "رتب السيرفر والبوديوم وتخصيص البطاقات",
      descriptionEn: "Server ranks, Podium and card customization",
    },
    {
      to: "/dashboard/bonus-xp",
      icon: Gift,
      label: "XP Bonus",
      labelAr: "بونص XP",
      labelEn: "XP Bonus",
      descriptionAr: "مضاعفات ومكافآت الخبرة",
      descriptionEn: "XP multipliers and rewards",
    },
    {
      to: "/dashboard/exclusions",
      icon: Ban,
      label: "XP Exclusion Control",
      labelAr: "الأستثناءات",
      labelEn: "XP Exclusion Control",
      descriptionAr: "إدارة استثناءات XP للقنوات والكاتاغوري والرولات",
      descriptionEn: "Manage XP exclusions for channels, categories, and roles",
    },
    {
      to: "/dashboard/notifications",
      icon: Bell,
      label: "Notifications",
      labelAr: "الإشعارات",
      labelEn: "Notifications",
      descriptionAr: "تنبيهات نظام المستويات",
      descriptionEn: "Level system notifications",
    },
    {
      to: "/dashboard/users",
      icon: Users,
      label: "User Management",
      labelAr: "إدارة المستخدمين",
      labelEn: "User Management",
      descriptionAr: "إدارة بيانات الأعضاء داخل النظام",
      descriptionEn: "Manage member data in the system",
    },
  ],
  welcome: [
    {
      to: "/dashboard/systems/welcome/join",
      icon: MessageSquare,
      label: "Welcome Message",
      labelAr: "رسالة الترحيب",
      labelEn: "Welcome Message",
      descriptionAr: "إعدادات رسالة الانضمام",
      descriptionEn: "Join message settings",
    },
    {
      to: "/dashboard/systems/welcome/leave",
      icon: DoorOpen,
      label: "Leave Message",
      labelAr: "رسالة الخروج",
      labelEn: "Leave Message",
      descriptionAr: "إعدادات رسالة المغادرة",
      descriptionEn: "Leave message settings",
    },
  ],
  automod: [
    {
      to: "/dashboard/systems/automod/moderation",
      icon: ShieldAlert,
      label: "Auto Moderation",
      labelAr: "الإشراف التلقائي",
      labelEn: "Auto Moderation",
      descriptionAr: "قواعد الرقابة التلقائية",
      descriptionEn: "Automated moderation rules",
    },
    {
      to: "/dashboard/systems/automod/violations",
      icon: AlertTriangle,
      label: "Violation Points System",
      labelAr: "نظام نقاط المخالفات",
      labelEn: "Violation Points System",
      descriptionAr: "إدارة النقاط والإجراءات",
      descriptionEn: "Violation points and actions",
    },
  ],
  logs: [
    {
      to: "/dashboard/logs",
      icon: ScrollText,
      label: "Logs System",
      labelAr: "نظام السجلات",
      labelEn: "Logs System",
      descriptionAr: "إعدادات السجلات والتتبع",
      descriptionEn: "Logging and audit settings",
    },
  ],
  commands: [
    {
      to: "/dashboard/systems/commands/general",
      icon: TerminalSquare,
      label: "General Commands",
      labelAr: "الأوامر العامة",
      labelEn: "General Commands",
      descriptionAr: "تفعيل وتعطيل الأوامر العامة وضبط قيودها",
      descriptionEn: "Manage public commands and restrictions",
    },
    {
      to: "/dashboard/systems/commands/moderation",
      icon: ShieldAlert,
      label: "Moderation Commands",
      labelAr: "أوامر الإشراف",
      labelEn: "Moderation Commands",
      descriptionAr: "إدارة أوامر الإشراف ورولات المشرفين",
      descriptionEn: "Manage moderation commands and moderator roles",
    },
  ],
  auto_roles: [
    {
      to: "/dashboard/systems/auto-roles",
      icon: Users,
      label: "Auto Roles",
      labelAr: "الرولات التلقائية",
      labelEn: "Auto Roles",
      descriptionAr: "إعدادات الرولات التلقائية للأعضاء والبوتات",
      descriptionEn: "Automatic role settings for members and bots",
    },
  ],
};

export const SYSTEM_SIDEBAR_ITEMS = {
  level: SYSTEM_SUBPAGES.level.map(toSidebarItem),
  welcome: SYSTEM_SUBPAGES.welcome.map(toSidebarItem),
  automod: SYSTEM_SUBPAGES.automod.map(toSidebarItem),
  logs: SYSTEM_SUBPAGES.logs.map(toSidebarItem),
  commands: SYSTEM_SUBPAGES.commands.map(toSidebarItem),
  auto_roles: SYSTEM_SUBPAGES.auto_roles.map(toSidebarItem),
};

